import { Location } from 'react-router-dom';
import commonSlice from '@/state/common.slice';
import store from '@/state/store';

export default (l: Location | null) => {
  store.dispatch(l ? commonSlice.actions.setExitPoint(l) : commonSlice.actions.clearExitPoint());
};